import { filterBy } from 'domain/Notifications/constants'
import PropTypes from 'prop-types'

export default PropTypes.oneOf([filterBy.PINNED_SHIPS, filterBy.PINNED_PORTS])
